import { useState } from 'react';

interface CopyButtonProps {
  value: string;
  label?: string;
}

/**
 * navigator.clipboard chi ton tai o ngu canh bao mat (https hoac localhost).
 * Tu host thuong chay http tren LAN, nen phai co duong lui bang textarea + execCommand,
 * neu khong thi nut copy im lang khong lam gi — kieu loi kho chiu nhat.
 */
async function copyText(value: string): Promise<boolean> {
  try {
    if (window.isSecureContext && typeof navigator.clipboard?.writeText === 'function') {
      await navigator.clipboard.writeText(value);
      return true;
    }
  } catch {
    // Roi xuong duong lui ben duoi.
  }
  try {
    const area = document.createElement('textarea');
    area.value = value;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(area);
    return ok;
  } catch {
    return false;
  }
}

export function CopyButton({ value, label = 'Copy' }: CopyButtonProps) {
  const [state, setState] = useState<'idle' | 'done' | 'fail'>('idle');

  return (
    <button
      type="button"
      className="cf-btn cf-btn-ghost shrink-0"
      onClick={() => {
        void copyText(value).then((ok) => {
          setState(ok ? 'done' : 'fail');
          // 1,8 giay du de doc chu "Da copy" ma khong de nut ket o trang thai la.
          window.setTimeout(() => setState('idle'), 1800);
        });
      }}
    >
      {state === 'done' ? 'Đã copy' : state === 'fail' ? 'Copy that bai' : label}
    </button>
  );
}
